import { ComponentProps } from 'react';
import FloatButton from 'antd/es/float-button';
import clsx from 'clsx';

interface OpFloatButtonProps extends ComponentProps<typeof FloatButton> {
  testId?: string;
  gtm?: string;
}

/**
 * OpFloatButton is a wrapper around Ant Design's FloatButton component.
 * It displays a floating action button that stays visible as users scroll.
 * 
 * Use this component for primary actions that should always be accessible, such as
 * "scroll to top", "help/support", or "create new item". Commonly positioned in
 * the bottom-right corner of the page.
 * 
 * @example
 * <OpFloatButton icon={<PlusOutlined />} onClick={handleCreate} />
 * <OpFloatButton.BackTop />
 * 
 */
export const OpFloatButton = ({
  className,
  testId = 'op-float-button',
  gtm,
  ...floatButtonProps
}: OpFloatButtonProps) => {
  return (
    <FloatButton
      className={clsx('op-float-button', className)}
      data-testid={testId}
      data-gtm={gtm}
      {...floatButtonProps}
    />
  );
};
